import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appSoloNumeros]'
})
export class SoloNumerosDirective {

  constructor(
    private elementRef: ElementRef, // para traer el elemento html
    private control: NgControl // para los formulario como FormGroup
    ) { }

  @HostListener('input', ['$event']) onInputChange(event: any){
    const numeroTelefono = this.elementRef.nativeElement.value;
    const numeroTelefonoSoloNumeros = numeroTelefono.replace(/[^0-9]/g, '');
    this.elementRef.nativeElement.value = numeroTelefonoSoloNumeros;
    this.control.control.patchValue(numeroTelefonoSoloNumeros, {emitEvent: false}) //el emitEvent : false es para evitar ciclos infinitos
    if(numeroTelefono !== this.elementRef.nativeElement.value){
        event.stopPropagation();
    }
  }

}
